// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"e5e33ecb","443":"f6c31601","711":"81b3a68c","898":"c558a8de","964":"3e1d66dc"}[chunkId] + ".chunk.js";
};